import i18n from "i18next";
import { initReactI18next } from "react-i18next";


// Importing translation files

import translationPT from "./locales/pt/translation.json";
import translationEN from "./locales/en/translation.json";
import translationES from "./locales/es/translation.json";
import translationFR from "./locales/fr/translation.json";


//Creating object with the variables of imported translation files
const resources = {
  pt: {
    translation: translationPT,
  },
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
  fr: {
    translation: translationFR,
  },
};

//i18N Initialization

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng:"pt", //default language
    fallbackLng: 'pt', // idioma de fallback se o idioma solicitado não estiver disponível
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;